import { SharedService } from './../../services/shared/shared.service';
import { Component, OnInit, Input,SimpleChanges  } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { LabelService } from 'src/app/services/label/label.service';
import { encodeURL } from 'src/app/services/parseURL';
import { Storage } from '@ionic/storage';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
import { ConsoleService } from 'src/app/services/console/console.service';



@Component({
    selector: 'app-item-grid',
    templateUrl: './item-grid.component.html',
    styleUrls: ['./item-grid.component.scss'],
})

export class ItemGridComponent implements OnInit {
    @Input() list: any;
    @Input() listType: string;
    @Input() subcatParentId: string;
    @Input() subcatParentName: string;
    @Input() title: string;
    @Input() style: any;
    useThumb: boolean;
    CO_CATEGORY_GRID_LABELS: any = {};
    colClass;
    designStudioActive;
    constructor(private router: Router, 
                private labelService: LabelService, 
                private platform: Platform, 
                private sharedService: SharedService, 
                private designStudioService:DesignStudioService,
                private consoleService:ConsoleService,
                private storage: Storage) {
                    this.consoleService.consoleLog('app-item-grid constructor', null);
                }
    async ngOnInit() {
        this.consoleService.consoleLog('app-item-grid ngOnInit', null);

        this.designStudioActive = this.designStudioService.designStudioActive;
        //this.consoleService.consoleLog('app-item-grid:41 designStudioActive',this.designStudioActive);
        //this.consoleService.consoleLog('app-item-grid:42 style',this.style);
        if (!this.style || Object.keys(this.style).length === 0 || !this.designStudioActive) {
            this.style = await this.designStudioService.getSessionStorageGlobalData();
            //this.consoleService.consoleLog('app-item-grid:45','no style');
            //this.consoleService.consoleLog('app-item-grid:45 style',this.style);
        }
        //this.consoleService.consoleLog('app-item-grid:46 style',this.style);
        this.colClass = `lg-col-${this.style.itemStyle.gridColumn.lg} md-col-${this.style.itemStyle.gridColumn.md} sm-col-${this.style.itemStyle.gridColumn.sm}`;
        this.CO_CATEGORY_GRID_LABELS = this.labelService.labels.CO_CATEGORY_GRID;
        let devWidth = this.platform.width();
        if (devWidth <= 786) {
            this.useThumb = !0
        } else if (devWidth > 786) {
            this.useThumb = !1
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        this.consoleService.consoleLog('app-item-grid ngOnChanges', null);
      }
    async openService(item) {
        const res = await this.sharedService.checkLoginStatus(`${this.CO_CATEGORY_GRID_LABELS['must_be_user_to_access_services_msg']}`);
        if (res) {
            const navigationExtras: NavigationExtras = {
                state: {
                    serviceData: item
                }
            };
            this.router.navigate(['service-response'], navigationExtras)
        }
    }
    urlName(name: string) {
        return encodeURL(name)
    }
    async setExclusive(item) {
        if (this.listType === 'categories') {}
        if (this.listType === 'subcategories') {}
    }
}